module.exports = __webpack_public_path__ + "img/score.b26ec1b8.png";